<template>
  <div class="NicknameChange">
    <section-header heading="2" ja="ニックネームを設定する"/>
    <div class="discription">
      <p>ひらがな・カタカナ・漢字・英数を使用した10文字以内のニックネームを設定してください</p>
      <p>現在のニックネーム：</p>
      <p>{{currentNickname}}</p>
      <p>新しいニックネーム</p>
    </div>
    <p-text-field
      placeholder="ニックネーム"
      v-model="nickname"
      @input="nickname"
    ></p-text-field>
    <div>
      <rule v-if="validateNickname(nickname) || validEmoji(nickname) || !nickname.length || nickname.length > 10">
        10文字以内のひらがな・カタカナ・漢字・英数で入力してください
      </rule>
      <normal-btn
        :disabled="validateNickname(nickname) || validEmoji(nickname) || !nickname.length || nickname.length > 10"
        @click="onOK">
        ニックネームを決定する
      </normal-btn>
    </div>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader.vue'
import NormalBtn from '../components/NormalBtn.vue'
import PTextField from "../components/PTextField"
import Rule from '../components/Rule.vue'
import Protobuf from '../mixins/protobuf'
import Screen from '../mixins/screen'
import Validator from '../mixins/validator'
import { replaceInputtableString } from "../assets/js/util";

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "NicknameChange",
  components: {
    SectionHeader,
    NormalBtn,
    PTextField,
    Rule
  },
  mixins: [
    Protobuf,
    Screen,
    Validator
  ],
  data () {
    return {
      currentNickname: this.$route.params.nickname,
      nickname: '',
      nicknameRules: [],
    }
  },
  computed: {
    nicknameRule() {
      return this.nicknameRules.length > 0 ? this.nicknameRules[0] : ''
    },
    validForm() {
      const err = this.validNickname(this.nickname)
      if (err !== null) {
        return false
      }
      return true
    },
  },
  methods: {
    validateNickname(nickname) {
      const searchTxt = "[①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡㍻〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼]";
      if(nickname.match(searchTxt)){
        return true;
      } else {
        return false;
      }
    },
    validEmoji(text) {
      const pattern = new RegExp("[^" +
      "\u0020-\u007F" + // Basic Latin
      "\u0370-\u03FF" + // Greek and Coptic
      "\u0400-\u04FF" + // Cyrillic
      "\u2000-\u206F" + // General Punctuation
      "\u2150-\u218F" + // Number Forms
      "\u2190-\u21FF" + // Arrows
      "\u2200-\u22FF" + // Mathematical Operators
      "\u2460-\u24FF" + // Enclosed Alphanumerics
      "\u25A0-\u25FF" + // Geometric Shapes
      "\u2600-\u26FF" + // Miscellaneous Symbols
      "\u2E80-\u2EFF" + // CJK Radicals Supplement
      "\u2F00-\u2FDF" + // Kangxi Radicals
      "\u3000-\u303F" + // CJK Symbols and Punctuation
      "\u3040-\u309F" + // Hiragana
      "\u30A0-\u30FF" + // Katakana
      "\u3200-\u32FF" + // Enclosed CJK Letters and Months
      "\u3300-\u33FF" + // CJK Compatibility
      "\u4E00-\u9FFF" + // CJK Unified Ideographs
      "\uF900-\uFAFF" + // CJK Compatibility Ideographs
      "\uFF00-\uFFEF" + // Halfwidth and Fullwidth Forms
      "]", 'g')
      if(text.match(pattern)){
        return true;
      } else {
        return false;
      }
    },
    inputtableText() {
      this.nickname = replaceInputtableString(this.nickname)
    },
    onOK () {
      const cmdNo = pb.PlayerUpdateInfoReq.CommandNo.COMMAND_NO
      const message = pb.PlayerUpdateInfoReq.create({
        updateType: pb.PlayerUpdateInfoReq.UpdateType.NICK_NAME,
        nickname: this.nickname,
      })
      const encorded = pb.PlayerUpdateInfoReq.encode(message).finish()
      this.post(cmdNo, encorded)
        .then(decoded => {
          if (decoded.status === pb.PlayerUpdateInfoResp.Status.SUCCESS) {
            this.$router.push({ name: 'nicknameChangeFinish', params: { nickname: this.nickname } })
          } else {
            this.$_error('Error', { title: '現在のニックネーム', statusCode: 100 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: '現在のニックネーム', statusCode: 100 })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.discription {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  p { margin-top: 10px; }
}
</style>
